import { type SegmentGlobalProps } from '../types';

/** Global event properties that should persist across logout resets. */
export const getDefaultGlobalEventProps = (): SegmentGlobalProps => ({
  app_version: process.env.APP_VERSION ?? '',
});
